<template>
  <v-row justify="center" align="center" class="mt-4">
    <v-col cols="12" sm="10">
      <v-card>
        <v-card-title class="headline">
          利用規約
        </v-card-title>
        <v-card-text class="text-subtitle-1">
<pre style="word-wrap: break-word; white-space: pre-wrap;">
合同会社ロケモAI 【ロケモシェア+（プラス）】利用規約

更新 2021-03-28

〇注意事項（利用規約概要）
投稿されたコンテンツは不正にダウンロード，転用される恐れがあります．
サーバのセキュリティの完全性を保証しません．また，あらゆる損害に対していかなる補償も行いません．
コンテンツは，本サービスから削除を行っても，インターネットの特性上完全に消去することはできません．
本サービスは，予告なく突然終了することがあります．
理由なくアカウントが停止されることがあります．
理由なくコンテンツ及びデータが削除されることがあります．
通常の公開範囲を超えて，コンテンツが閲覧，公開されることがあります．その際も当社は一切の責任を負いません．


本サービス利用規約（以下，「本規約」とする）を以下の通り定めます．
利用規約は常に最新版が適用されます．
合同会社ロケモAI（以下，「当社」とする）が本規約のいずれかの権利または規定を行使しない場合にも，これをもってその権利または規定が放棄されたとはみなされません．


1，規約適応範囲
本規約は，当社の様々なウェブサイト，API，メール通知，アプリケーション，広告などのサービス（以下，「本サービス」とする）と，本サービスに関連してアップロード，ダウンロードまたは表示される情報，テキスト，リンク，グラフィック，写真，音声，動画，その他のマテリアルやアレンジされたマテリアル（以下，「コンテンツ」と総称する）にアクセス，利用する場合に適用される．
利用者は本サービス，またはコンテンツを利用することによって，本規約に同意したとみなされる．
なお，当社が本サービスにおいて不適切と認めたコンテンツは，当社の判断によりコンテンツを削除できるものとする．


2，アカウント
本サービスの一部の機能を使用するためにはアカウントを作成する必要がある．
アカウントの作成時に虚偽の報告をしてはならない．また，登録情報の誤り，更新があった場合には直ちに修正を行うものとする．
アカウントは他者に貸出，譲渡してはならない．
なりすましを目的として，他者と同じ，もしくは類似する，もしくは誤解を与えるアカウントを作成してはならない．
なお，当社が本サービスにおいて不適切と認めたアカウントは，当社の判断によりアカウントの利用停止およびアカウント削除できるものとする．


3，禁止行為
著作権，肖像権をはじめとする他者の権利を侵害してはならない．
著作者の許諾を得ていないコンテンツ，またはそれらを使用したコンテンツを投稿してはならない．
本サービスのリバースエンジニアリング，ソースコードの転用，サーバへの不正アクセスをしてはならない．
一般の利用の範囲を超えて，本サービスにアクセスしてはならない（自動システム，ロボット，スパイダーや，過剰な再読み込み行為等を含む)．
コンテンツのコピー，複製，録音，録画，ダウンロードを行ってはならない（投稿者が許可した場合に，本サービス提供者の提示する形式に則って行う場合はその限りではない）．
コンテンツのコピー，複製，録音，録画，ダウンロードの目的でアクセスしてはならない（そのようなアプリ，ソフトウェア，プログラム等の使用を含む）．
通称「釣り」と呼ばれる行為，内容とタイトル，概要欄，使用する画像に著しく差があってはならない．また，あえて誤解を招く言い回し，表現をしてはならない．
有害，不快，性的，暴力的，グロテスク，危険行為及び違法行為を収録したコンテンツ，またそれらに類似するコンテンツ，人種，民族，宗教，障がい，性的嗜好や性同一性等に対する暴力行為，差別意識，誹謗中傷などを助長，推進または許容するコンテンツ，略奪，ストーカー行為，脅迫，いやがらせ，恐喝，プライバシーの侵害，個人情報の漏えいをはじめとした違法行為，嫌がらせ行為を助長，推進するコンテンツ，なりすましを目的として，他者と同じ，もしくは類似する，もしくは誤解を与えるコンテンツ，その他サービス提供者が不適切だと判断したコンテンツの投稿を禁止する．
本サービスの妨害や当社が提供するインターフェースおよび手順以外の方法を使った本サービスへのアクセス，本サービスの不正利用をしてはならない．
本サービス，当社のコンピュータシステム，または当社システムの非公開部分へのアクセス，不正な改ざんもしくは使用，システムもしくはネットワークの脆弱性の探索，スキャンもしくはテスト，またはセキュリティもしくは認証方法の侵害もしくは回避をしてはならない．
当社の現在利用可能な公開インターフェース以外の方法で，本サービスへのアクセスもしくはその探索またはその試み，方法の如何を問わず，改ざんされた情報，詐欺的情報もしくは情報源を偽装した情報を送る目的での本サービスの利用，他利用者，ホストもしくはネットワークのアクセスの妨害または遮断とその試み，ウィルスの送信，オーバーロード，フラッディング，スパミングを行ってはならない．


4，著作権等権利
利用者はコンテンツに対する所有権を全て所有する．
ただし，利用者は，それらコンテンツの一部又は全部の，世界的，非独占的，無償，サブライセンス可能かつ譲渡可能な，本コンテンツの使用，複製，配布，派生著作物の作成，表示，出版，翻案，送信可能化及び実演に関するライセンスを，本サービス，本サービス提供者，また当社に付与する．
なお，このラインセンスは当該コンテンツがサーバから削除されるまで続くものとする．
また，本サービスを通じての利用者の本コンテンツへのアクセス，並びに本コンテンツを使用，複製，配布，派生著作物の作成，表示，出版，送信可能化及び実演することについての非独占的なライセンスを付与する．


5，補償
本サービスの利用によって利用者が負ういかなる損害，不利益に関しても，本サービス提供者は一切の責任を負わないものとする．
また，利用者間で発生した紛争は当事者で解決するものとする．


6，料金
本サービスの利用料金は別途定めるとおりとする．
なお，本サイトの利用において発生したデータ通信料，発生した紛争，損害への賠償，慰謝料等は，各利用者が負担するものとする．


7，サービス
本サービスは，利用者の許可なく停止，変更，削除，またデータの削除，初期化がなされることがある．
また，通信速度，動作の保証を行わない．
当社ならびにその第三者プロバイダーおよびパートナーが，本サービス上に広告を掲載すること，コンテンツもしくは本サービスから得られる情報に関連した広告を掲載することに同意するものとする．
当社は，当社と本サービスの利用者および社会全体の権利，財産もしくは安全を保護するために，当社が必要であると合理的に判断する一切の情報について，アクセス，閲覧，保存，および公開する権利を得る．


8，特権
当社は，投稿物，コンテンツ，コメント，利用者情報他全ての情報の削除権限を無条件に有するものとする．
また，アカウントの凍結，停止，同一メールアドレス，IPアドレス，MACアドレス等からアクセスを禁止，サービスの提供を拒否する権限を持つ．


9，追加
本サービスは「Amazon」の「Amazon Web Service」を利用している．「Amazon Web Service」の規約はこの規約より上位に位置し，矛盾がある場合は「Amazon Web Service」の規約を優先して適応するものとする．

「AWS 利用規約」：https://aws.amazon.com/jp/aup/

「AWS サービス条件」：https://d1.awsstatic.com/legal/awsserviceterms/AWS%20Service%20Terms%20-%20Japanese%20Translation%20(2018-10-05)%20Clean.pdf

「AWS 法務関連」：https://aws.amazon.com/jp/legal/

ユーザは，ユーザの定める「投稿規約」を正当な範囲で遵守する必要があり，違反によってアカウントの停止などの処置を行う場合がある．
ただし，「投稿規約」が不当であると判断される場合にはその限りではなく，「投稿規約」に強制力は無いとする．
          </pre>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

export default {
  created() {
    console.log("created");
    this.init();
  },
  mounted: function () {
    console.log("mounted");
  },
  methods: {
    init: function () {
      this.$store.commit('set', {
        key: "title",
        val: "利用規約"
      });
    },
  },
  computed: {
    user: function () {
      return this.$store.getters.user;
    },
    isSignedIn: function () {
      return this.$store.getters.isSignedIn;
    },
    title: function () {
      return this.$store.getters.get.title;
    },
  },
};
</script>
